export const buildTree = (data) => {
  const map = new Map();

  // data.forEach((node) => {
  //   if (!map.has(node.ItemId)) {
  //     map.set(node.ItemId, { ...node, children: [] });
  //   }
  // });

  // const tree = [];

  // data.forEach((node) => {
  //   if (node.parentId !== null) {
  //     if (map.has(node.parentId)) {
  //       const parent = map.get(node.parentId);
  //       const child = map.get(node.ItemId);

  //       if (!parent.children.includes(child)) {
  //         parent.children.push(child);
  //       }
  //     }
  //   } else {
  //     tree.push(map.get(node.ItemId));
  //   }
  // });

  const tree = [];

  // Step 1: Store nodes in the map
  data.forEach((node) => {
    if (!map[node.itemId]) {
      map[node.itemId] = [];
    }
    map[node.itemId].push({ ...node, children: [] });
  });

  // Step 2: Assign children correctly
  data.forEach((node) => {
    if (node.parentId !== "0") {
      if (map[node.parentId]) {
        map[node.parentId].forEach((parent) => {
          map[node.itemId].forEach((child) => {
            if (!parent.children.some((c) => c.itemId === child.itemId)) {
              parent.children.push(child);
            }
          });
        });
      }
    }
  });

  // Step 3: Collect root nodes
  data.forEach((node) => {
    if (node.parentId === "0") {
      tree.push(...map[node.itemId]);
    }
  });

  console.log("map", map);
  return tree;
};

export const isLeafNode = (node) => node.children.length === 0;
